import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const breadcrumbLabelKeys: Record<string, string> = {
  dashboard: "breadcrumbs.dashboard",
  "manage-car-washes": "breadcrumbs.manageCarWashes",
  "manage-owners": "breadcrumbs.manageOwners",
  info: "carWashes.tabInfo",
  "contact-details": "carWashes.tabContactDetails",
  statistics: "carWashes.tabStatistics",
  "washing-history": "carWashes.tabWashingHistory",
  prices: "carWashes.tabPrices",
  "relationship-manager": "manageCarWashes.relationshipManager",
  "support-cases": "carWashes.tabSupportCases",
  logs: "carWashes.tabLogs",
};

export default function BaseBreadcrumbs() {
  const location = useLocation();
  const { t } = useTranslation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Breadcrumbs aria-label={t("breadcrumbs.aria")} sx={{ color: "white" }}>
      <Link
        component={RouterLink}
        underline="hover"
        color="inherit"
        to="/dashboard"
        sx={{ color: "white" }}
      >
        {t("nav.home")}
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? (
          <span key={to} className="text-white">
            {breadcrumbLabelKeys[value] ? t(breadcrumbLabelKeys[value]) : value}
          </span>
        ) : (
          <Link
            component={RouterLink}
            underline="hover"
            color="inherit"
            sx={{ color: "white" }}
            to={to}
            key={to}
          >
            {breadcrumbLabelKeys[value] ? t(breadcrumbLabelKeys[value]) : value}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
